export {default} from './ReportRecordDefaultLoading';
